// extracted by mini-css-extract-plugin
export default {"password":"password___ff1a1b6d19af49a9","icon":"icon___a6cc7dbaeb3c5005"};